import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import PriceChecker from '../../PriceChecker';

const baseCls = 'checkout-price-changed';

const SidebarPrice = ({ className, showPriceChanged, children, isMobile }) => (
  <div
    className={classNames(className, {
      [baseCls]: showPriceChanged,
    })}
  >
    {isMobile && children}
    <PriceChecker />
    {!isMobile && children}
  </div>
);

SidebarPrice.defaultProps = {
  className: null,
  children: null,
};

SidebarPrice.propTypes = {
  className: PropTypes.string,
  showPriceChanged: PropTypes.bool.isRequired,
  children: PropTypes.node,
  isMobile: PropTypes.bool.isRequired,
};

export default SidebarPrice;
